export const setUserInfo = payload => ({
  type:'SET_INFOUSUARIO',
  payload,
});
